import __ from './__';

export default (value: string): string | null => {
  if (typeof value !== 'undefined' && String(value).trim()) {
    return null;
  }
  return __('Pole je povinné');
};
